var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.44 1.586 1.931 5.983a.814.814 0 0 0 .303.421c.14.101.31.16.496.16l6.287-.014c.335 0 .642.103.893.285.253.184.446.444.55.76.103.319.1.644.004.94-.099.296-.287.56-.556.755l-5.095 3.687a.823.823 0 0 0-.305.937l1.956 5.977a1.505 1.505 0 0 1-.55 1.695 1.509 1.509 0 0 1-.89.291c-.312 0-.621-.098-.89-.293l-5.08-3.707A.85.85 0 0 0 12 19.3a.847.847 0 0 0-.493.162l-5.08 3.707a1.504 1.504 0 0 1-1.78.002 1.505 1.505 0 0 1-.55-1.695L6.05 15.5a.826.826 0 0 0-.303-.937L.652 10.876c-.269-.195-.46-.46-.556-.755a1.512 1.512 0 0 1 .005-.94c.103-.316.296-.576.549-.76.251-.182.558-.285.892-.285l6.288.014a.827.827 0 0 0 .798-.58l1.931-5.984c.103-.316.296-.579.547-.762.254-.184.563-.287.893-.287.332 0 .641.103.895.287.25.184.444.446.547.762Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgStar;